import type { Theme } from '@mui/material';

export const styles = {
  accordion: {
    boxShadow: 'none',
    border: 'none',
    p: '0 !important',
    m: '0 !important',

    '&:before': {
      content: 'none',
    },
  },

  accordionSummary: (theme: Theme) => ({
    border: `1px solid ${theme.colors.neutral[200]}`,
    borderRadius: '0.5rem 0.5rem 0 0',
    padding: '1rem 0.5rem 0.5rem',
    justifyContent: 'flex-start',
    backgroundColor: theme.colors.neutral[50],
    minHeight: '0 !important',

    '> *': {
      flexGrow: '0 !important',
      m: '0 !important',
    },
  }),

  accordionExpansionIcon: (theme: Theme) => ({
    fill: theme.colors.primary[600],
  }),

  accordionDetails: (theme: Theme) => ({
    border: `1px solid ${theme.colors.neutral[200]}`,
    borderBottom: 'None',
    px: 1,
    py: 2,
  }),

  accordionFooter: (theme: Theme) => ({
    border: `1px solid ${theme.colors.neutral[200]}`,
    borderTop: `1px solid ${theme.colors.neutral[100]}`,
    borderRadius: '0 0 0.5rem 0.5rem',
    height: '2rem',
  }),
};
